import React, { useMemo } from "react";
import "./FilterChips.css";

function FilterChips({
  criterios,
  onChange,
  projects = [],
  permisionarios = [],
  states = [],
  clients = [],
  companies = [],
  height = "auto",
}) {
  const activeFilters = useMemo(
    () =>
      Object.entries(criterios).filter(
        ([_, value]) =>
          value !== null &&
          ((typeof value === "string" && value !== null) ||
            (typeof value === "object" && value?.id !== null))
      ),
    [criterios]
  );

  if (activeFilters.length === 0) return null;

  const prettyKeyLabel = (key) => {
    const map = {
      nombre: "Centro de carga",
      puntoCarga: "Punto de carga",
      rpu: "RPU",
      proyecto: "Proyecto",
      cliente: "Cliente",
      permisionario: "Permisionario",
      empresa: "Empresa",
      estado: "Estado",
      nivelTension: "Nivel de tensión",
      demandaContratada: "Demanda contratada",
      porcentajeFotos: "% Fotos",
      porcentajeParametros: "% Parámetros",
    };
    return map[key] || key;
  };

  const formatValue = (key, value) => {
    switch (key) {
      case "proyecto": {
        const project = projects.find((p) => p.id === value?.id);
        return project?.nombre ?? `Proyecto ${value?.id}`;
      }
      case "permisionario": {
        const perm = permisionarios.find((p) => p.id === value?.id);
        return perm?.razonSocial ?? `Permisionario ${value?.id}`;
      }
      case "estado": {
        const state = states.find((s) => s.id === value?.id);
        return state?.nombreEstado ?? `Estado ${value?.id}`;
      }
      case "cliente": {
        const client = clients.find((c) => c.id === value?.id);
        return client?.nombre ?? client?.razonSocial ?? `Cliente ${value?.id}`;
      }
      case "empresa": {
        const company = companies.find((c) => c.id === value?.id);
        return (
          company?.nombre ?? company?.razonSocial ?? `Empresa ${value?.id}`
        );
      }
      case "demandaContratada": {
        if (typeof value === "string") {
          const [from, to] = value.split("-");
          return `${Number(from).toLocaleString()} - ${Number(
            to
          ).toLocaleString()} kW`;
        }
        return String(value);
      }
      default: {
        if (typeof value === "object") {
          return JSON.stringify(value);
        }
        return String(value);
      }
    }
  };

  const handleRemove = (key) => {
    onChange({
      ...criterios,
      [key]: null,
    });
  };

  return (
    <div className="filter-chips-container">
      {activeFilters.map(([key, value]) => (
        <div key={key} className="filter-chip" style={{ height: height }}>
          <span className="filter-chip-text">
            <strong>{prettyKeyLabel(key)}</strong>: {formatValue(key, value)}
          </span>
          <button
            type="button"
            className="filter-chip-close"
            onClick={() => handleRemove(key)}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

export default FilterChips;
